import { Link } from "react-router-dom"

function TermsAndConditions() {
    return (
        <>
            <div className="privacy px-3 pt-3">
                <h3 className="fw-semibold Privacy_head">Terms and Conditions for CareerSahi Platform</h3>
                <p><span className="fw-bold">Effective Date:</span> 01/01/2025</p>
                <section>
                    <h3 className="fw-semibold">Introduction</h3>
                    <p>Welcome to CareerSahi ("we," "our," or "us"). These Terms and Conditions ("Terms") govern your access to and use of the CareerSahi platform ("Platform") and services. By accessing or using our Platform, you agree to comply with and be bound by these Terms. Please read them carefully before proceeding.</p>
                </section>

                <p>Thank you for trusting CareerSahi with your information.</p>

                <section>
                    <h3 className="fw-semibold">1. Acceptance of Terms</h3>
                    <p>By using our Platform, you confirm that you have read, understood, and agree to these Terms. If you do not agree to these Terms, you must not use our Platform.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">2. Use of the Platform</h3>
                    <p><strong className="fw-semibold">a. Eligibility:</strong></p>
                    <ul>
                        <li>The Platform is designed for individuals of all ages seeking career guidance and counseling.</li>
                        <li>If you are under 18 years of age, you may use the Platform under the supervision and consent of a parent or legal guardian.</li>
                    </ul>
                    <p><strong className="fw-semibold">b. User Obligations:</strong></p>
                    <ul>
                        <li>Provide accurate and complete information during registration.</li>
                        <li>Use the Platform only for lawful purposes.</li>
                        <li>Refrain from any activity that disrupts the functionality or security of the Platform.</li>
                    </ul>
                </section>
                <section>
                    <h3 className="fw-semibold">3. Account Responsibility</h3>
                    <p>You are responsible for maintaining the confidentiality of your account credentials. You agree to notify us immediately of any unauthorized access or use of your account. CareerSahi will not be liable for any loss or damage resulting from your failure to secure your account.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">4. Payment and Refund Policy</h3>
                    <p>All payments made on the Platform are subject to our <strong className="fw-semibold">Refund Policy</strong>. By making a purchase, you agree to the terms outlined in our Refund Policy.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">5. Intellectual Property Rights</h3>
                    <p>All content on the Platform, including text, graphics, logos, and software, is the property of CareerSahi or its licensors and is protected by intellectual property laws. You may not copy, reproduce, distribute, or create derivative works from our content without prior written consent.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">6. Prohibited Activities</h3>
                    <p>You agree not to:</p>
                    <ul>
                        <li>Use the Platform for fraudulent or malicious purposes.</li>
                        <li>Upload or transmit viruses or harmful code.</li>
                        <li>Attempt to reverse-engineer, decompile, or disassemble any part of the Platform.</li>
                        <li>Engage in any activity that infringes on the rights of others.</li>
                    </ul>
                </section>
                <section>
                    <h3 className="fw-semibold">7. Limitation of Liability</h3>
                    <p>To the fullest extent permitted by law, CareerSahi shall not be liable for any indirect, incidental, or consequential damages arising from your use of the Platform.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">8. Termination</h3>
                    <p>We reserve the right to suspend or terminate your access to the Platform at our sole discretion, without notice, if you violate these Terms or engage in unlawful activities.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">9. Changes to Terms</h3>
                    <p>We may update these Terms from time to time. Any changes will be effective when posted on the Platform. Your continued use of the Platform after such changes signifies your acceptance.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">10. Governing Law</h3>
                    <p>These Terms shall be governed by and construed in accordance with the laws of [Insert Jurisdiction]. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts in Surat Jurisdiction.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">11. Contact Us</h3>
                    <p>If you have any questions or concerns about these Terms, please contact us at:</p>
                    <address>
                        <strong className="fw-semibold">CareerSahi</strong><br />
                        Email: <strong className="fw-semibold">  <Link to="mailto:info@careersahi.com" className="text-decoration-none fw-semibold pointer text-black">
                            info@careersahi.com
                        </Link></strong><br />
                        Phone: <strong className="fw-semibold">+91 82382 35437</strong>
                    </address>
                </section>
                <p>Thank you for choosing CareerSahi. We are committed to helping you achieve your career goals.</p>
            </div>
        </>
    )
}
export default TermsAndConditions